import { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { customStyles } from "../../../../assets/table-style";
import { format } from "date-fns";
import { useServerPagination } from "../../../../hooks/customHook/paginationHook/useServerPagination";
import { PaginationControls } from "../../../../hooks/customHook/paginationHook/usePagination";
import BASE_URL from "../../../../assets/global/url";

const columns = [
  {
    name: "Transaction Number",
    selector: (row) => row.transaction_number || "---",
  },
  {
    name: "Process Date",
    selector: (row) =>
      row.process_date
        ? format(new Date(row.process_date), "MMM/dd/yyyy")
        : "---",
  },
  {
    name: "Type",
    selector: (row) => row.type || "---",
  },
];

const ExpensesHistoryModal = ({ show, onHide, expensesId }) => {
  const DATA_URL = `${BASE_URL}/paylocalexpenses/getPaymentHistory/${expensesId}`;
  const pagination = useServerPagination("about:blank", 10, {}, 1);

  useEffect(() => {
    if (show && expensesId) {
      pagination.updateApiUrl(DATA_URL);
      pagination.updateParams({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, expensesId]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      keyboard={false}
      size="lg"
      backdrop="static"
      dialogClassName="custom-modal-vw90"
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Payment History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="data-table-cell-width">
          <DataTable
            columns={columns}
            data={pagination.data}
            customStyles={customStyles}
            className="dataTable"
          />
          <PaginationControls {...pagination} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export { ExpensesHistoryModal };
